import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:57
* @route '/api/admin/document-types'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/admin/document-types',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:57
* @route '/api/admin/document-types'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:57
* @route '/api/admin/document-types'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:57
* @route '/api/admin/document-types'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::store
* @see app/Http/Controllers/Admin/DocumentTypeController.php:85
* @route '/api/admin/document-types'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/admin/document-types',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::store
* @see app/Http/Controllers/Admin/DocumentTypeController.php:85
* @route '/api/admin/document-types'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::store
* @see app/Http/Controllers/Admin/DocumentTypeController.php:85
* @route '/api/admin/document-types'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::show
* @see app/Http/Controllers/Admin/DocumentTypeController.php:104
* @route '/api/admin/document-types/{documentType}'
*/
export const show = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/api/admin/document-types/{documentType}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::show
* @see app/Http/Controllers/Admin/DocumentTypeController.php:104
* @route '/api/admin/document-types/{documentType}'
*/
show.url = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { documentType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { documentType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            documentType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        documentType: typeof args.documentType === 'object'
        ? args.documentType.id
        : args.documentType,
    }

    return show.definition.url
            .replace('{documentType}', parsedArgs.documentType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::show
* @see app/Http/Controllers/Admin/DocumentTypeController.php:104
* @route '/api/admin/document-types/{documentType}'
*/
show.get = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::show
* @see app/Http/Controllers/Admin/DocumentTypeController.php:104
* @route '/api/admin/document-types/{documentType}'
*/
show.head = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::update
* @see app/Http/Controllers/Admin/DocumentTypeController.php:114
* @route '/api/admin/document-types/{documentType}'
*/
export const update = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/admin/document-types/{documentType}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::update
* @see app/Http/Controllers/Admin/DocumentTypeController.php:114
* @route '/api/admin/document-types/{documentType}'
*/
update.url = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { documentType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { documentType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            documentType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        documentType: typeof args.documentType === 'object'
        ? args.documentType.id
        : args.documentType,
    }

    return update.definition.url
            .replace('{documentType}', parsedArgs.documentType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::update
* @see app/Http/Controllers/Admin/DocumentTypeController.php:114
* @route '/api/admin/document-types/{documentType}'
*/
update.put = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::destroy
* @see app/Http/Controllers/Admin/DocumentTypeController.php:144
* @route '/api/admin/document-types/{documentType}'
*/
export const destroy = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/admin/document-types/{documentType}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::destroy
* @see app/Http/Controllers/Admin/DocumentTypeController.php:144
* @route '/api/admin/document-types/{documentType}'
*/
destroy.url = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { documentType: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { documentType: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            documentType: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        documentType: typeof args.documentType === 'object'
        ? args.documentType.id
        : args.documentType,
    }

    return destroy.definition.url
            .replace('{documentType}', parsedArgs.documentType.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::destroy
* @see app/Http/Controllers/Admin/DocumentTypeController.php:144
* @route '/api/admin/document-types/{documentType}'
*/
destroy.delete = (args: { documentType: number | { id: number } } | [documentType: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const documentTypes = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default documentTypes